<template>
    <ValidationObserver ref="form">
        <div class="box-offset">
            <div class="box-ttl-wrap">
                <div class="box-ttl">
                    Personal
                </div>
            </div>
            <div class="my-profile-block">
                <div class="avatar-block">
                    <div class="user-link">
                        <div class="avatar"

                             :style="{'background-image': avatar ? getNameOfAvatar(avatar): `url(/img/add-img.png)`}">
                            <a href="javascript:void(0)" class="photo-edit">
                                <img src="/img/svg/icons-pen-white.svg" @click="$refs.imageInput.click()" class="icon" alt="">
                            </a>
                            <input
                                type="file"
                                style="display: none"
                                @change="onImageSelected"
                                ref="imageInput"
                                accept="image/*"
                            >
                        </div>
                    </div>
                </div>
                <div class="my-info-block">
                    <div class="row">

                        <ValidationProvider
                            class="col-md-6"
                            name="First Name"
                            rules="required|latin|min:2|max:100"
                            v-slot="{ errors }"
                        >
                            <div class="form-group form-group-1">
                                <label for="" class="form-label">First Name</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="form.name"
                                >
                                <FormError :error="errors[0]" name="First Name"></FormError>
                            </div>
                        </ValidationProvider>

                        <ValidationProvider
                            class="col-md-6"
                            name="Last Name"
                            rules="required|latin|min:2|max:100"
                            v-slot="{ errors }"
                        >
                            <div class="form-group form-group-1">
                                <label for="" class="form-label">Last Name</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="form.last_name">
                                <FormError :error="errors[0]" name="Last Name"></FormError>
                            </div>
                        </ValidationProvider>

                        <ValidationProvider
                            class="col-md-6"
                            name="Phone number"
                            v-slot="{ errors }"
                            rules="required"
                        >
                            <div class="form-group form-group-1">
                                <label for="" class="form-label">Phone Number </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="form.cell_number"
                                    v-mask="'+1 (###) ###-####'"
                                >
                                <FormError :error="errors[0]"  name="Phone number"></FormError>
                            </div>
                        </ValidationProvider>

                        <ValidationProvider
                            class="col-md-6"
                            name="Email"
                            rules="required|email"
                            v-slot="{ errors }"
                        >
                            <div class="form-group form-group-1">
                                <label for="" class="form-label">Email Address</label>
                                <input
                                    type="email"
                                    class="form-control"
                                    v-model="form.email"
                                >
                                <FormError :error="errors[0]" name="Email"></FormError>
                            </div>
                        </ValidationProvider>

                        <ValidationProvider
                            class="col-md-6"
                            name="password"
                            rules="min:6"
                            v-slot="{ errors }"
                        >
                            <div class="form-group form-group-1">
                                <label for="" class="form-label">New Password</label>
                                <input type="password"
                                       class="form-control"
                                       v-model="form.password_confirmation"
                                       ref="password"
                                       :readonly="!changingPassword"
                                >
                                <FormError :error="errors[0]" name="password"></FormError>
                            </div>
                        </ValidationProvider>

                        <ValidationProvider
                            class="col-md-6"
                            name="conf password"
                            rules="confirmed:password"
                            v-slot="{ errors }"

                        >
                            <div class="form-group form-group-1">
                                <label for="" class="form-label">Confirm New Password</label>
                                <input
                                    type="password"
                                    class="form-control"
                                    v-model="confirmPassword"
                                    data-vv-as="password"
                                    :readonly="!changingPassword"
                                >
                                <FormError :error="errors[0]" name="conf password"></FormError>
                            </div>
                        </ValidationProvider>

                        <ValidationProvider
                            class="col-md-6"
                            name="job"
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <div class="form-group form-group-1">
                                <label for="" class="form-label">Job Title </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="form.job_title"
                                >
                                <FormError :error="errors[0]" name="job"></FormError>
                            </div>
                        </ValidationProvider>

                        <div class="col-md-6">
                            <label for="" class="form-label">Status</label>
                            <div class="buttons-type-multiselect two-btns ">
                                <div class="item active-green">
                                    <input
                                        type="radio"
                                        class="rad" id="id-1132"
                                        value="active"
                                        v-model="form.status"
                                    >
                                    <label for="id-1132">
                                        <div class="ttl">Active</div>
                                    </label>
                                </div>
                                <div class="item inactive">
                                    <input
                                        type="radio"
                                        class="rad" id="id-1212"
                                        value="inactive"
                                        v-model="form.status"
                                    >
                                    <label for="id-1212">
                                        <span class="ttl">Inactive</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="btns-wrap mt-4">
                <a href="/master-admin/settings/users" class="btn btn--outline-primary w-100 w-sm-auto">Cancel</a>
                <button  class="btn btn--secondary w-100 w-sm-auto" @click="updateUserInfo">Save</button>
            </div>
        </div>
    </ValidationObserver>


</template>

<script>
import UsersServices from "../services/UsersServices";
import ApplicantsServices from "../../../../Applicants/resources/js/services/ApplicantsServices";
import StyleHandler from "../../../../../../resources/js/mixins/StyleHandler";

export default {
    name: 'Personal',
    props: {
        userAvatar: {
            type: String,
        },
        changingPassword: {
            type: Boolean,
        },
        personal: {
            type: Object,
            required: true
        },
        id: {
            type: Number
        }
    },
    mixins: [StyleHandler],
    data() {
        return {
            selectedFile: null,
            confirmPassword: null,
            avatar: this.userAvatar,
            form: this.personal,
        }
    },
    methods: {
        onImageSelected(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    this.selectedFile = file;
                    this.uploadPhoto();
                };
                reader.readAsDataURL(file);
            }
        },
        async uploadPhoto() {
            this.$showLoadingMessage()
            if (this.selectedFile) {
                let formData = new FormData();
                formData.append('photo', this.selectedFile);
                try {
                    const response = await ApplicantsServices.uploadPhoto(this.id, formData);
                    this.avatar = response.data.url
                    this.getNameOfAvatar(this.avatar)
                    this.$showSuccessMessage('The avatar was successfully updated')
                } catch (e) {
                    console.error(e);
                    this.$showErrorMessage("The photo was not uploaded");
                }
            }
        },
        async updateUserInfo() {
            this.$showLoadingMessage()
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            }
            try {
                const payload = {
                    ...this.form,
                    password: this.confirmPassword ?? this.personal.password,
                    avatar: this.avatar
                }
                await UsersServices.updateUserPersonalInfo(this.id, payload)
                this.$showSuccessMessage('The user has been updated')
                setTimeout(()=> {

                }, 1000)
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The user info was not updated')
            }
        }
    },
}

</script>


<style scoped>

</style>
